import { Link } from "react-router-dom";
import { POSTS } from "../lib/content";
import { Reveal, MaskReveal } from "../components/Reveal";

// Sort posts by date, newest first — defensive in case content.js order ever drifts.
const SORTED = [...POSTS].sort((a, b) => new Date(b.date) - new Date(a.date));

export default function Journal() {
  const [feature, ...rest] = SORTED;
  return (
    <div className="pt-32 md:pt-40 pb-24" data-testid="journal-page">
      <section className="relative container-edge overflow-hidden">
        {/* Cinematic printing-press backdrop */}
        <video
          className="absolute inset-0 -z-0 w-full h-full object-cover opacity-[0.14] pointer-events-none"
          src="https://customer-assets.emergentagent.com/job_brand-proposal-site/artifacts/728gw0rf_printing-newspapers-in-typography-SBV-329702759-HD.mp4"
          autoPlay muted loop playsInline preload="auto"
          aria-hidden
        />
        <div className="relative z-10">
        <div className="overline text-ink/60">The Journal — Issue 26</div>
        <MaskReveal delay={0.05}>
          <h1 className="font-display uppercase text-7xl md:text-[12vw] leading-[0.82] mt-4">
            Notes from <span className="serif-italic font-serif normal-case">the desk</span>.
          </h1>
        </MaskReveal>
        </div>
      </section>

      <section className="container-edge mt-20 grid grid-cols-12 gap-x-8 gap-y-10 items-end" data-testid="journal-feature">
        <Link to={`/journal/${feature.slug}`} className="col-span-12 md:col-span-7 group" data-cursor="hover" data-testid="feature-link">
          <div className="overflow-hidden">
            <img src={feature.img} alt={feature.title} loading="eager" fetchPriority="high" decoding="async" className="w-full aspect-[4/3] object-cover img-bw group-hover:grayscale-0 group-hover:scale-[1.02] transition-all duration-1000" />
          </div>
        </Link>
        <div className="col-span-12 md:col-span-5">
          <Reveal>
            <div className="overline text-ink/55">Feature · {feature.category}</div>
            <Link to={`/journal/${feature.slug}`} className="block group">
              <h2 className="font-serif text-4xl md:text-5xl leading-tight mt-4 group-hover:underline decoration-1 underline-offset-8 transition-all">{feature.title}</h2>
            </Link>
            <p className="text-ink/75 text-lg mt-5 leading-relaxed">{feature.excerpt}</p>
            <div className="overline text-ink/50 mt-8">{feature.author} · {feature.date}</div>
            <Link to={`/journal/${feature.slug}`} className="overline mt-6 inline-block text-ink hover:opacity-60" data-testid="feature-cta">
              Read the feature →
            </Link>
          </Reveal>
        </div>
      </section>

      <section className="container-edge mt-32 md:mt-40 grid grid-cols-1 md:grid-cols-3 gap-y-16 gap-x-10 md:gap-x-12">
        {rest.map((p, i) => (
          <Reveal key={p.slug} delay={(i % 3) * 0.06} className="group">
            <Link to={`/journal/${p.slug}`} className="block" data-cursor="hover" data-testid={`journal-card-${p.slug}`}>
              <article>
                <div className="overflow-hidden">
                  <img src={p.img} alt={p.title} loading="lazy" decoding="async" className="w-full aspect-[4/5] object-cover img-bw group-hover:scale-105 transition-transform duration-[1200ms]" />
                </div>
                <div className="overline text-ink/55 mt-4">{p.category} · {p.date}</div>
                <h3 className="font-serif text-2xl md:text-3xl leading-snug mt-2 group-hover:underline decoration-1 underline-offset-4 transition-all">{p.title}</h3>
                <p className="text-ink/70 mt-3">{p.excerpt}</p>
              </article>
            </Link>
          </Reveal>
        ))}
      </section>
    </div>
  );
}
